


















































































































import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import { resolveModule } from '@/store';
import { BuildingsModule } from '@/store/dashboard/buildings/BuildingsModule';
import { QueryBuildingsData } from '@/modules/backend/Dto/QueryBuildingsData';
import BuildingAddDialog from '@/components/buildings/BuildingAddDialog.vue';
import BuildingDeleteButton from '@/components/buildings/BuildingDeleteButton.vue';
import ProvidersModule from '@/store/dashboard/providers/ProvidersModule';
import { Building } from '@/modules/backend/Entities/Building';
import DataTableWrapper from '@/layouts/DataTableWrapper.vue';
import { DataTableHeader } from 'vuetify';
import Mixin from '@/mixins/base';
import SortMixin from '@/mixins/sort';
import { CompaniesModule } from '@/store/dashboard/companies/CompaniesModule';
import { emptyPlaceholder } from '@/filters/emptyPlaceholder';

const debounceTimeouts: number[] = [];

@Component({
  mixins: [Mixin, SortMixin],
  filters: { emptyPlaceholder },
  components: {
    DataTableWrapper,
    'building-add-dialog': BuildingAddDialog,
    'building-delete-button': BuildingDeleteButton
  }
})
export default class Buildings extends Mixins(Mixin, SortMixin) {
  private readonly companiesModule: CompaniesModule = resolveModule(CompaniesModule);
  private readonly buildingsModule: BuildingsModule = resolveModule(BuildingsModule);
  private readonly providersModule: ProvidersModule = resolveModule(ProvidersModule);

  private readonly chosenCompanies: number[] = [];
  private readonly chosenProviders: number[] = [];

  @Prop({ type: Array, default: () => [] }) private readonly companies!: number[];

  @Prop({ type: Array, default: () => [] }) private readonly providers!: number[];

  private loading = false;

  private page = 1;

  private get actualChosenCompanies(): number[] {
    return [...this.chosenCompanies, ...this.companies];
  }

  private get actualChosenProviders(): number[] {
    return [...this.chosenProviders, ...this.providers];
  }

  private get buildings(): Building[] {
    if (!this.actualChosenCompanies.length && !this.actualChosenProviders.length) {
      return this.buildingsModule.Buildings;
    }

    try {
      return this.buildingsModule.Buildings.filter(building => {
        return this.actualChosenCompanies.includes(building.getCompany().getId()) ||
          this.actualChosenProviders.some(providerId => building.getProviders().map(provider => provider.getId()).includes(providerId));
      });
    } catch {
      return [];
    }
  }

  private get headers(): DataTableHeader[] {
    return [
      {
        text: this.isDesktop ? this.$t('common.table.headers.id').toString() : this.$t('common.table.headers.id_short').toString(),
        sortable: false,
        value: 'id'
      },
      {
        text: this.$t('screens.buildings.dialog_fields.address').toString(),
        value: 'address'
      },
      {
        text: this.$t('screens.buildings.dialog_fields.companies').toString(),
        value: 'companies'
      },
      {
        text: this.$t('common.table.headers.actions').toString(),
        sortable: false,
        value: 'actions',
        align: 'end'
      }
    ];
  }

  @Watch('chosenCompanies')
  @Watch('chosenProviders')
  private async chosenCompaniesChangedHandler(): Promise<void> {
    const DEBOUNCE_TIMEOUT = 1000;

    clearTimeout(debounceTimeouts[0]);
    setTimeout(async () => {
      await this.refreshBuildings();
    }, DEBOUNCE_TIMEOUT);
  }

  private async loadData(): Promise<void> {
    this.loading = true;

    await Promise.all([
      this.refreshBuildings(),
      this.companiesModule.Fetch(),
      this.providersModule.fetch()
    ]);

    this.loading = false;
  }

  private async refreshBuildings(): Promise<void> {
    await this.buildingsModule.Fetch(new QueryBuildingsData().fromPlain({
      companies: [...this.chosenCompanies, ...this.companies],
      providers: [...this.chosenProviders, ...this.providers],
      page: this.page
    }));
  }

  private getBuildingLocations(buildings: Building): string {
    const locations = buildings.getName();
    if (locations) {
      return locations;
    }

    return '—';
  }

  private getBuildingCompany(buildings: Building): string {
    const company = buildings.getCompany().getName();
    if (company) {
      return company;
    }

    return '—';
  }

  private customSort(items: Building[], index: string[], isDescending: boolean[]): Building[] {
    items.sort((a, b): number => {
      if (index[0] === 'address') {
        return this.stringComparator(
          this.getBuildingLocations(a),
          this.getBuildingLocations(b),
          isDescending[0]
        );
      }

      if (index[0] === 'companies') {
        return this.stringComparator(
          this.getBuildingCompany(a),
          this.getBuildingCompany(b),
          isDescending[0]
        );
      }

      return 0;
    });

    return items;
  }

  public async mounted(): Promise<void> {
    await this.loadData();
  }
}
